import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import logo from '../../assets/logo.png';
import { Button, Dropdown, Grid, Icon, Image, Menu } from 'semantic-ui-react';
import styles from './App.scss';
import { AvailabilityChecker } from '../Modules';
import OptionsMenu from './OptionsMenu';

export default class Header extends React.Component {
  static propTypes = {
    viewer: PropTypes.object,
    router: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      lastMounted: new Date()
    };
    this.transition = this.transition.bind(this);
  }

  transition(e) {
    e.preventDefault();
    this.props.router.push(e.target.getAttribute('to') || '/');
  }

  render() {
    const { viewer, ...rest } = _.omit(this.props, 'router');
    return (
      <Grid
        padded
        style={{
          boxShadow: '0px 1px 3px 0px #DEDEDF, 0px 0px 0px 1px #DEDEDF',
          padding: '0 2em'
        }}
        verticalAlign='middle'
        className={styles.header}
        {...rest}
      >
        <Grid.Row
          only='computer'
          style={{ padding: '0.325em 0 0.325em 0', minHeight: '48px' }}
        >
          <Grid.Column floated='left' style={{ width: '220px' }}>
            <a to='/' onClick={this.transition}>
              <Image src={logo} style={{ height: '22px' }} />
            </a>
          </Grid.Column>
          <Grid.Column
            style={{ flex: 2, height: '100%', position: 'relative' }}
          >
            <div style={{ position: 'absolute', width: '100%' }}>
              {this.props.viewer &&
                <div>
                  <Button
                    primary
                    size='small'
                    content='Add Event'
                    to='/events/new'
                    onClick={this.transition}
                  />
                  <Menu text compact style={{ marginLeft: '2em' }}>
                    <Menu.Item
                      name='All Events'
                      to='/'
                      onClick={this.transition}
                      active={
                        location.pathname.match(/^\/$/) !== null
                      }
                      className={styles.headerMenuItem}
                    />
                    <Menu.Item
                      name='Calendar'
                      to='/calendar'
                      onClick={this.transition}
                      active={
                        location.pathname.match(/^\/calendar(\/(.)*)?$/) !== null
                      }
                      className={styles.headerMenuItem}
                    />
                    <Dropdown
                      item
                      text='More'
                      className={styles.headerMenuItem}
                    >
                      <Dropdown.Menu>
                        <Dropdown.Item
                          to='/pipelines'
                          onClick={this.transition}
                          active={
                            location.pathname.match(/^\/pipelines(\/(.)*)?$/) !==
                            null
                          }
                        >
                          Pipeline
                        </Dropdown.Item>
                        <Dropdown.Item
                          to='/financials'
                          onClick={this.transition}
                          active={
                            location.pathname.match(/^\/financials(\/(.)*)?$/) !==
                            null
                          }
                        >
                          Financials
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </Menu>
                </div>}
            </div>
          </Grid.Column>
          <Grid.Column style={{ flex: 1 }} floated='right' textAlign='right'>
            {this.props.viewer &&
              <div>
                <a
                  className={styles.searchIcon}
                  onClick={() => this.props.router.push('/search')}
                >
                  <Icon name='search' />
                </a>
                <AvailabilityChecker viewer={viewer} />
                <OptionsMenu viewer={viewer} router={this.props.router} />
              </div>}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/App/HeaderComponent.js